import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Link, Container, Typography, Stack, Button } from '@material-ui/core';
import plusFill from '@iconify/icons-eva/plus-fill';
import Icon from '@material-ui/core/Icon';

CommonPageHeader.propTypes = {
    sx: PropTypes.object,
    path: PropTypes.string,
    btname: PropTypes.string,
    pageName: PropTypes.string
};
export default function CommonPageHeader({ sx, path, btname, pageName, leftButtonHidden }) {
    const navigate = useNavigate();


    const getIcon = () => {
        let iconName = "backspaceIcon"
        if (btname.includes("Add") || btname.includes("New")) {
            iconName = "add";
        }
        return iconName;
    }

    function navigateToDirection() {
        navigate(path);
    }

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>

            <Typography variant="h4" gutterBottom>
                {pageName}
            </Typography>
            {leftButtonHidden === true ?
                null
                :
                <Button
                    variant="contained"
                    to="#"
                    color='secondary'
                    onClick={() => navigateToDirection()}
                    startIcon={<Icon>{getIcon()}</Icon>}
                >
                    {btname}
                </Button>
            }



        </Stack>

    );
}
